import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import historyStyles from 'styles/css/VisitHistory.module.scss';
import sharedStyles from 'styles/css/SharedStyles.module.scss';
import mainStyles from 'styles/css/Main.module.scss';
import { WEBSITE, API_VISIT_HISTORY } from 'apis';
import apiRequest from 'utils/apiRequest';
import { handleChangeDataVisitHistoryPage } from 'reduxx/actions/pages/myAdvice/history';
import { Link } from 'react-router-dom';
import ForwardIcon from 'styles/images/svg/forward-white.svg';
import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import { handleChangeDataModalRating } from "reduxx/actions/partials/modals/modalRating";

const VisitHistory = () => {

    const dispatch = useDispatch();

    const { token } = useSelector(state => state.login);
    const { history } = useSelector(state => state.visitHistory);

    useEffect(() => {
        apiMyAdvice();
    }, [VisitHistory]);

    const apiMyAdvice = () => {
        apiRequest({
            dispatch,
            endpoint: API_VISIT_HISTORY,
            method: 'post',
            data: {width: window.innerWidth},
            ...(token && { token }),
            successMessage: null,
            onSuccess: (res) => {
                dispatch(handleChangeDataVisitHistoryPage('history', res.history));
            }
        });
    };

    const toPersianDigits = (num) => {
        return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    };

    const showModal = (uniqueCode, doctorName) => {
        let data = {
            uniqueCode, 
            doctorName
        };
        dispatch(handleChangeDataModalRating('data', data));
        dispatch(handleChangeDataModalRating('isOpen', true));
    };

    return (
        
        <div className={[sharedStyles.container, sharedStyles['px-[16px]'], sharedStyles['pb-[64px]']].join(' ')} >

            <ShortHeaderWithBackBtn />

            {
                history.map((item, index) => (
                    <div className={[historyStyles['card-visit-history'], item.status === "done" ? historyStyles.finished : historyStyles.pending].join(' ')}>

                        <div className={[historyStyles.boxTitle, item.status === "done" ? historyStyles.finished : historyStyles.pending].join(' ')}>
                            <div className={[sharedStyles.flex, sharedStyles.justifyBetween, sharedStyles.itemsCenter].join(' ')}>
                                <span>شماره درخواست:</span>
                                <span className={sharedStyles['font-weight-600']}>{toPersianDigits(item.regDate)}</span>
                            </div>
                            <div className={[sharedStyles.flex, sharedStyles.justifyBetween, sharedStyles.itemsCenter].join(' ')}>
                                <span className={sharedStyles['font-weight-600']}>{item.uniqueCode}</span>
                                <span>{toPersianDigits(item.regTime)}</span>
                            </div>
                        </div>
                            

                        <div className={[sharedStyles.flex, sharedStyles.itemsCenter, sharedStyles.gapLg, sharedStyles['mt-[8px]']].join(' ')}>
                            { item.doctorName !== null && item.doctorName.length > 0 ?
                                <>
                                <img src={`${WEBSITE}images/doctors/${item.doctorImage}`} alt={item.doctorName} className={historyStyles.doctorImage} />
                                <span>{item.doctorName}</span>
                                </>
                                :
                                <>
                                <div className={historyStyles.doctorImage} style={{width: '68px', height: '68px'}} />
                                <span>دکتر مشخص نشده</span>
                                </>
                            } 
                            
                        </div>

                        <span className={sharedStyles['mt-[8px]']}>{item.statusTxt}</span>

                        { item.status === "done" ?
                            <div className={[sharedStyles.flex, sharedStyles.itemsCenter, sharedStyles.gapLg, sharedStyles['mt-[8px]']].join(' ')}>
                                <Link onClick={() => item.rate === null ? showModal(item.uniqueCode, item.doctorName) : {}} className={[historyStyles.btn, historyStyles.btnRating, sharedStyles['flex-1'], sharedStyles.flex, sharedStyles.justifyCenter].join(' ')} >
                                    { item.rate === null ?
                                        'ثبت امتیاز'
                                        :
                                        `امتیاز شما ${toPersianDigits(item.rate)} از ۵`
                                    }
                                </Link>

                                <div className={[sharedStyles['flex-1'], sharedStyles.flex].join(' ')} style={{position: "relative"}}>
                                    <Link to={`${item.uniqueCode}`} className={[historyStyles.btn, historyStyles.btnDetailsOff, sharedStyles['flex-1'], sharedStyles.flex, sharedStyles.justifyCenter].join(' ')} >
                                        تاریخچه گفت و گو
                                    </Link>
                                    { item.unreadCount > 0 &&
                                    <span style={{backgroundColor: "red", color: "white", position: "absolute", width: "20px", height: "20px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "small", top: "0px", left: "0px", transform: "translateX(-30%) translateY(-30%)"}}>
                                        {toPersianDigits(item.unreadCount)}
                                    </span>
                                    }
                                </div>
                            </div>
                            :
                            <div style={{position: "relative"}}>
                                <Link to={`${item.uniqueCode}`} className={[mainStyles['cta-full'], sharedStyles.flex, sharedStyles.justifyBetween, sharedStyles['mt-[8px]']].join(' ')} style={{width: 'unset', paddingTop: '7px', paddingBottom: '7px', textDecoration: 'none'}}>
                                    <div style={{width: '20px'}}/>
                                    <span>ورود به گفت و گو</span>
                                    <img src={ForwardIcon} width={20} />
                                </Link>
                                { item.unreadCount > 0 &&
                                <span style={{backgroundColor: "red", color: "white", position: "absolute", width: "20px", height: "20px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "small", top: "0px", left: "0px"}}>
                                    {toPersianDigits(item.unreadCount)}
                                </span>
                                }
                            </div>
                                
                        }
                    </div>
                ))
            }
                
        </div>

    );
}

export default VisitHistory;